export default __webpack_public_path__ + "static/media/guest_mute.c8fcaf29.svg";